import { html, css, LitElement } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';
import { formatUnixTimestamp } from '../../../utils/unixTimeConverter';

const formatTime = (date) => {
  const options = { hour: '2-digit', minute: '2-digit', hour12: true, timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone };
  return new Intl.DateTimeFormat('en-US', options).format(date);
};



export class Timestamp extends LitElement {
  static properties = {
    time: { type: String },
    color: { type: String },
    fontSize: { type: String },
    textAlign: { type: String },
    fontFamily: { type: String },
    fontWeight: { type: Number }
  };

  constructor() {
    super();
    // this.time = new Date().toISOString();
    this.color = 'gray';
    this.fontSize = '12px';
    this.textAlign = 'right';
    this.fontFamily = 'sans-serif,Arial';
    this.fontWeight = 400;
    
  }

  render() {
    
    const formattedTime = formatTime(new Date(Number(this.time)));
    return html`
      <div style=${styleMap({ 
        color: this.color, 
        fontSize: this.fontSize, 
        textAlign: this.textAlign, 
        fontFamily: this.fontFamily,
        fontWeight:this.fontWeight
      })}>
        ${formattedTime}
      </div>
    `;
  }
}

customElements.define('timestamp-element', Timestamp);
